import { Component, computed, input } from '@angular/core';
import { IntlDurationPipe } from '@app/shared/pipes/intl-duration.pipe';
import { TimeReportSumUp } from '@app/shared/utils/time-report-sum-up.aggregation';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

const SUM_UP_ABSENCE_LABEL_KEY = 'time-reports-filters.kind-absence';

@Component({
  selector: 'sum-up-hours-panel',
  imports: [IntlDurationPipe, TranslatePipe],
  templateUrl: './sum-up-hours-panel.component.html',
  standalone: true
})
export class SumUpHoursPanelComponent {
  protected readonly summary = input.required<TimeReportSumUp>();

  protected readonly visibleRows = computed(() => {
    const summary = this.summary();
    return [
      {
        key: 'ordinary',
        label: 'time-report-hour-type-ordinary-hours',
        minutes: summary.ordinaryMinutes
      },
      {
        key: 'bankPlus',
        label: 'time-report-hour-type-bank_plus',
        minutes: summary.bankPlusMinutes
      },
      {
        key: 'bankMinus',
        label: 'time-report-hour-type-bank_minus',
        minutes: summary.bankMinusMinutes
      },
      {
        key: 'overtime50',
        label: 'time-report-hour-type-overtime_50',
        minutes: summary.overtime50Minutes
      },
      {
        key: 'overtime100',
        label: 'time-report-hour-type-overtime_100',
        minutes: summary.overtime100Minutes
      },
      {
        key: 'workTimeTotal',
        label: 'time-reports.total-time-tracked',
        minutes: summary.workTimeTotalMinutes
      },
      {
        key: 'absence',
        label: SUM_UP_ABSENCE_LABEL_KEY,
        minutes: summary.absenceTotalMinutes
      }
    ]
      .filter(row => row.minutes > 0)
      .map(row => ({
        key: row.key,
        label: row.label,
        isoDuration: minutesToIsoDuration(row.minutes)
      }));
  });
}

function minutesToIsoDuration(minutes: number): string {
  return moment.duration(minutes, 'minutes').toISOString();
}
